/**
 * Subset of backend UserAction values that are valid for frontend use.
 * A compile-time check in shared-backend ensures every value here
 * exists in the backend UserAction enum.
 */
export enum FrontendUserAction {
  AudioPlayed = "AUDIO_PLAYED",
  PlaylistPlayed = "PLAYLIST_PLAYED",
}
